import { customElement } from 'lit/decorators.js';
import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { tagName } from '../../../helpers/element.helper';

const tag = tagName('dropdown-arrow');

@customElement(tag)
export class DropdownArrowComponent extends TmElement {
  protected override render() {
    return html`
      <svg
        width="32"
        height="31"
        viewBox="0 0 32 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_1794_2971)">
          <path
            d="M24.002 2.95425C25.2221 1.57506 27.5 2.43801 27.5 4.2794V25H4.5L24.002 2.95425Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1794_2971"
            x="0.5"
            y="0.275391"
            width="31"
            height="30.7246"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1794_2971"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1794_2971"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-dropdown-arrow': DropdownArrowComponent;
  }
}
